import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LecturerList from './lecturer_list';
import LecturerDetail from './lecturer_detail';

class Lecturer extends Component {
  componentDidMount(){
  }
  render() {
    //console.log(this.context);
    var params = this.context.router.route.match.params;
    var view;
    if(params.action===undefined){
      view = <LecturerList/>;
    }else{
      if(params.id===undefined){
        view = <LecturerDetail/>;
      }else{
        view = <LecturerDetail action={params.action}/>;
      }
    }
    return (
      <div className="page-wrapper">{view}</div>
    );
  }
}

Lecturer.contextTypes = {
  router: PropTypes.object
};

export default Lecturer;
